import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    createEvent,
    createEventFieldStatus,
    createEventOrder,
    creatStationMaster,
    editEvent,
    editStaionMaster,
    eventFieldStatusListById,
    eventLastStage,
    eventList,
    eventListById,
    eventStatusUpdate,
    stationMasterDelete,
    stationMasterList,
    stationMasterUpdate
} from "../../services/api";
import { secretKey } from "../../services/config";
import EncryptDecrypt from "../../utils/encrypt&decrypt";
import alertmessage from "../../utils/alert";
const namespace = "event";

// Add Event
export const addEvent = createAsyncThunk(
    `${namespace}/addEvent`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await createEvent({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Get Event List
export const getEventList = createAsyncThunk(
    `${namespace}/getEventList`,
    async (
        { query = "", page = 0, limit = 0, sortby = "", order = "", id = "" },
        { rejectWithValue }
    ) => {
        try {
            const data = await eventList(query, page, limit, sortby, order, id);
            return JSON.parse(EncryptDecrypt.decryptdata(data?.data?.datas, secretKey));
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Get Event by ID
export const getEventById = createAsyncThunk(
    `${namespace}/getEventById`,
    async ({ id }, { rejectWithValue }) => {
        try {
            const data = await eventListById(id);
            return JSON.parse(EncryptDecrypt.decryptdata(data?.data?.datas, secretKey));
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const getEventFieldStatusById = createAsyncThunk(
    `${namespace}/getEventFieldStatusById`,
    async ({ id, spec_id }, { rejectWithValue }) => {
        try {
            const data = await eventFieldStatusListById(id, spec_id);
            return JSON.parse(EncryptDecrypt.decryptdata(data?.data?.datas, secretKey));
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Update Event
export const updateEvent = createAsyncThunk(
    `${namespace}/UpdateEvent`,
    async ({ postData, updateID }, { rejectWithValue }) => {
        try {
            let payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await editEvent({ payload }, updateID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
//update field status
export const addFieldEventStatus = createAsyncThunk(
    `${namespace}/addFieldEventStatus`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await createEventFieldStatus({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Update Event Status
export const updateEventStatus = createAsyncThunk(
    `${namespace}/UpdateStatus`,
    async ({ postData, updateID }, { rejectWithValue }) => {
        try {
            let payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await eventStatusUpdate({ payload }, updateID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

//update event order
export const updateEventOrder = createAsyncThunk(
    `${namespace}/updateEventOrder`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await createEventOrder({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const updateEventLastStage = createAsyncThunk(
    `${namespace}/updateEventLastStage`,
    async ({ editID }, { rejectWithValue }) => {
        try {
            // const payload = EncryptDecrypt.encryptdata(editID, secretKey);
            const data = await eventLastStage({ editID });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

//create station number
export const addStationMaster = createAsyncThunk(
    `${namespace}/addStationMaster`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await creatStationMaster({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

//find all Staton master
export const getStationMasterList = createAsyncThunk(
    `${namespace}/getStationMasterList`,
    async (
        { query = "", page = 0, limit = 0, sortby = "", order = "", id = "" },
        { rejectWithValue }
    ) => {
        try {
            const data = await stationMasterList(query, page, limit, sortby, order, id);
            return JSON.parse(EncryptDecrypt.decryptdata(data?.data?.datas, secretKey));
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

//update station master
export const updateStationMaster = createAsyncThunk(
    `${namespace}/updateStationMaster`,
    async ({ postData, updateID }, { rejectWithValue }) => {
        try {
            let payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await editStaionMaster({ payload }, updateID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

//delete station master
export const deleteStationMaster = createAsyncThunk(
    `${namespace}/deleteStationMaster`,
    async ({ deleteID }, { rejectWithValue }) => {
        try {
            const data = await stationMasterDelete(deleteID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const updateStationMasterStatus = createAsyncThunk(
    `${namespace}/updateStationMasterStatus`,
    async ({ postData, updateID }, { rejectWithValue }) => {
        try {
            let payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await stationMasterUpdate({ payload }, updateID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
// Slice
const eventSlice = createSlice({
    name: namespace,
    initialState: {
        eventListData: [],
        eventLoading: false,
        addEventSuccess: false,
        addEventError: false,
        addEventErrorMessage: "",
        eventListByIdData: [],
        eventListByIdError: false,
        updateEventSuccess: false,
        updateEventError: false,
        updateEventErrorMessage: "",
        eventStatusSuccess: false,
        eventStatusError: false,
        eventStatusErrorMessage: "",
        addFieldEventStatusSuccess: false,
        addFieldEventStatusError: false,
        addFieldEventStatusErrorMessage: "",
        eventFieldStatusData: [],
        eventOrderSuccess: false,
        eventOrderError: false,
        eventOrderErrorMessage: "",
        updateEventLastStageSuccess: false,
        updateEventLastStageError: false,
        updateEventLastStageErrorMessage: "",
        addStationMasterSuccess: false,
        addStationMasterError: false,
        addStationMasterErrorMessage: '',
        StationMasterListData: [],
        updateStaionMasterSuccess: false,
        updateStaionMasterError: false,
        updateStaionMasterErrorMessage: "",
        deleteStationMasterSuccess: false,
        deleteStationMasterError: false,
        deleteStationMasterErrorMessage: "",
        updateStationMasterStatusSuccess: false,
        updateStationMasterStatusError: false,
        updateStationMasterStatusErrorMessage: "",
    },
    reducers: {
        resetSuccessFlag: (state, action) => {
            const { flag } = action.payload;
            state[flag] = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(addEvent.pending, (state) => {
                state.eventLoading = true;
                state.addEventError = false;
            })
            .addCase(addEvent.fulfilled, (state) => {
                state.eventLoading = false;
                state.addEventSuccess = true;
            })
            .addCase(addEvent.rejected, (state, action) => {
                state.addEventError = true;
                state.eventLoading = false;
                state.addEventErrorMessage = action.payload?.data?.message || "An error occurred";
            })
            .addCase(getEventList.pending, (state) => {
                state.eventLoading = true;
            })
            .addCase(getEventList.fulfilled, (state, action) => {
                state.addEventSuccess = false;
                state.updateEventSuccess = false;
                state.addEventError = false;
                state.addFieldEventStatusSuccess = false;
                state.updateEventLastStageSuccess = false
                state.eventOrderSuccess = false
                state.eventListData = action.payload;
                state.eventLoading = false;
            })
            .addCase(getEventList.rejected, (state, action) => {
                state.eventLoading = false;
                if (action?.payload?.data?.auth === "deleted") {
                    alertmessage.sweetalert(action?.payload?.data?.message);
                }
            })
            .addCase(getEventById.pending, (state) => {
                state.eventLoading = true;
            })
            .addCase(getEventById.fulfilled, (state, action) => {
                state.addEventError = false;
                state.eventLoading = false;
                state.addFieldEventStatusSuccess = false;
                state.eventListByIdData = action.payload;
            })
            .addCase(getEventById.rejected, (state) => {
                state.eventLoading = false;
            })
            .addCase(updateEvent.pending, (state) => {
                state.eventLoading = true;
            })
            .addCase(updateEvent.fulfilled, (state) => {
                state.eventLoading = false;
                state.updateEventSuccess = true;
            })
            .addCase(updateEvent.rejected, (state, action) => {
                state.updateEventError = true;
                state.updateEventErrorMessage = action.error.message || "An error occurred";
            })
            .addCase(updateEventStatus.pending, (state) => {
                state.eventLoading = true;
            })
            .addCase(updateEventStatus.fulfilled, (state) => {
                state.eventStatusSuccess = true;
                state.eventLoading = false;
            })
            .addCase(updateEventStatus.rejected, (state, action) => {
                state.eventStatusError = true;
                state.eventLoading = false;
                state.eventStatusErrorMessage = action.payload.data?.message || "An error occurred";
            })
            .addCase(addFieldEventStatus.pending, (state) => {
                state.eventLoading = true;
            })
            .addCase(addFieldEventStatus.fulfilled, (state) => {
                state.addFieldEventStatusSuccess = true;
                state.eventLoading = false;
            })
            .addCase(addFieldEventStatus.rejected, (state, action) => {
                state.addFieldEventStatusError = true;
                state.eventLoading = false;
                state.addFieldEventStatusErrorMessage = action.payload.data?.message || "An error occurred";
            })
            .addCase(getEventFieldStatusById.pending, (state) => {
                state.eventLoading = true;
            })
            .addCase(getEventFieldStatusById.fulfilled, (state, action) => {
                state.eventLoading = false;
                state.eventFieldStatusData = action.payload;
                state.addFieldEventStatusSuccess = false;
            })
            .addCase(getEventFieldStatusById.rejected, (state, action) => {
                state.eventLoading = false;
                state.eventFieldStatusData = [];
                if (action?.payload?.data?.auth === "deleted") {
                    alertmessage.sweetalert(action?.payload?.data?.message);
                }
            })
            .addCase(updateEventOrder.pending, (state) => {
                state.eventLoading = true;
            }).addCase(updateEventOrder.fulfilled, (state) => {
                state.eventLoading = false;
                state.eventOrderSuccess = true;
            }
            ).addCase(updateEventOrder.rejected, (state, action) => {
                state.eventLoading = false;
                state.eventOrderError = true;
                state.eventOrderErrorMessage = action.payload?.data?.message || "An error occurred";
            })
            .addCase(addStationMaster.pending, (state) => {
                state.eventLoading = true;
                state.addStationMasterError = false;
            })
            .addCase(addStationMaster.fulfilled, (state) => {
                state.eventLoading = false;
                state.addStationMasterSuccess = true;
                state.addStationMasterError = false;
            })
            .addCase(addStationMaster.rejected, (state, action) => {
                state.addStationMasterError = true;
                state.addStationMasterSuccess = false;
                state.eventLoading = false;
                state.addStationMasterErrorMessage = action.payload?.data?.message || "An error occurred";
            })
            .addCase(getStationMasterList.pending, (state) => {
                state.eventLoading = true;
            })
            .addCase(getStationMasterList.fulfilled, (state, action) => {
                state.StationMasterListData = action.payload;
                state.updateStationMasterStatusSuccess = false;
                state.addStationMasterSuccess = false
                state.updateStaionMasterSuccess = false
                state.eventLoading = false;
            })
            .addCase(getStationMasterList.rejected, (state, action) => {
                state.eventLoading = false;
                if (action?.payload?.data?.auth === "deleted") {
                    alertmessage.sweetalert(action?.payload?.data?.message);
                }
            })
            .addCase(updateStationMaster.pending, (state) => {
                state.eventLoading = true;
            })
            .addCase(updateStationMaster.fulfilled, (state) => {
                state.eventLoading = false;
                state.updateStaionMasterSuccess = true;
                state.updateStationMasterStatusSuccess = false;
                state.updateStaionMasterError = false;
            })
            .addCase(updateStationMaster.rejected, (state, action) => {
                state.updateStaionMasterError = true;
                state.updateStaionMasterSuccess = false;
                state.addStationMasterError = false;
                state.updateStaionMasterErrorMessage = action.payload.data.message || "An error occurred";
            })
            .addCase(deleteStationMaster.pending, (state) => {
                state.eventLoading = true;
            })
            .addCase(deleteStationMaster.fulfilled, (state) => {
                state.eventLoading = false;
                state.deleteStationMasterSuccess = true;
            })
            .addCase(deleteStationMaster.rejected, (state, action) => {
                state.deleteStationMasterError = true;
                state.deleteStationMasterErrorMessage = action.error.message || "An error occurred";
            })
            .addCase(updateEventLastStage.pending, (state) => {
                state.eventLoading = true;
            })
            .addCase(updateEventLastStage.fulfilled, (state) => {
                state.eventLoading = false;
                state.updateEventLastStageSuccess = true;
            })
            .addCase(updateEventLastStage.rejected, (state, action) => {
                state.updateEventLastStageError = true;
                state.eventLoading = false;
                state.updateEventLastStageErrorMessage = action.payload?.data?.message || "An error occurred";
            })
            .addCase(updateStationMasterStatus.pending, (state) => {
                state.eventLoading = true;
            })
            .addCase(updateStationMasterStatus.fulfilled, (state) => {
                state.eventLoading = false;
                state.updateStationMasterStatusSuccess = true;
            })
            .addCase(updateStationMasterStatus.rejected, (state, action) => {
                state.updateStationMasterStatusError = true;
                state.eventLoading = false;
                state.updateStationMasterStatusErrorMessage = action.payload?.data?.message || "An error occurred";
            });
    },
});

export const { resetSuccessFlag } = eventSlice.actions;
export const eventSelector = (state) => state[namespace];
export default eventSlice.reducer;
